import React from 'react';
import LoadingIcon from '../Icons/LoadingIcon';

import cl from 'classnames';
import s from './Button.css';

const leftPosition = 'left';
const rightPosition = 'right';

function addClassName(elem, className) {
  return React.cloneElement(elem, {
    className: cl(className, elem.props.className)
  });
}

const Button = ({
  children,
  icon,
  iconPosition = leftPosition,
  loading,
  className,
  style,
  ...props
}) => (
  <button
    className={cl(s.Button, loading && s.HideContent, className)}
    style={style}
    disabled={loading}
    {...props}
  >
    <LoadingIcon size="2em" className={cl(s.Loading, loading && s.Active)} />
    {icon && iconPosition === leftPosition
      ? addClassName(icon, s.LeftIcon)
      : null}
    {children}
    {icon && iconPosition === rightPosition
      ? addClassName(icon, s.RightIcon)
      : null}
  </button>
);

export default Button;
